import { pushToDataLayer } from '@/lib/pushToDataLayer.ts';

export type CtaLocation = 'hero' | 'header' | 'more_companies';

export const trackCtaClick = (ctaLocation: CtaLocation) => {
  pushToDataLayer({
    event: 'apply_click',
    cta_location: ctaLocation,
  });
};
